import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mb_token";
const USER_KEY = "mb_user";
// Stashed admin session — set BEFORE swapping into an impersonated user so
// the admin can return to their own account with one click. Cleared when
// they exit impersonation (or manually log out).
const ADMIN_STASH_KEY = "mb_admin_stash";

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  getUser: () => {
    const u = localStorage.getItem(USER_KEY);
    return u ? JSON.parse(u) : null;
  },
  setUser: (u) => localStorage.setItem(USER_KEY, JSON.stringify(u)),
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(ADMIN_STASH_KEY);
  },
  // ── Admin impersonation helpers ──────────────────────────────────────
  stashAdminSession: () => {
    const t = localStorage.getItem(TOKEN_KEY);
    const u = localStorage.getItem(USER_KEY);
    if (t && u) localStorage.setItem(ADMIN_STASH_KEY, JSON.stringify({ token: t, user: JSON.parse(u) }));
  },
  getStashedAdmin: () => {
    const s = localStorage.getItem(ADMIN_STASH_KEY);
    return s ? JSON.parse(s) : null;
  },
  clearStashedAdmin: () => localStorage.removeItem(ADMIN_STASH_KEY),
};

export const api = axios.create({ baseURL: API, timeout: 60000 });

api.interceptors.request.use((config) => {
  const t = auth.getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      auth.clear();
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register") && window.location.pathname !== "/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
